/**
 * rem适配工具函数
 * 以360px屏幕宽度为基准，动态设置html的font-size
 * 支持设备兼容性和横竖屏切换
 */

// 基准屏幕宽度
const BASE_WIDTH = 360
// 基准font-size (1rem = 20px)
const BASE_FONT_SIZE = 20

/**
 * 设置html的font-size
 * @param {number} width - 当前屏幕宽度
 */
function setHtmlFontSize(width) {
  const fontSize = (width / BASE_WIDTH) * BASE_FONT_SIZE
  document.documentElement.style.fontSize = fontSize + 'px'
}

/**
 * 初始化rem适配
 */
function initRem() {
  // 获取当前屏幕宽度
  const width = document.documentElement.clientWidth || window.innerWidth
  
  // 设置初始font-size
  setHtmlFontSize(width)
  
  // 监听窗口大小变化
  window.addEventListener('resize', () => {
    const newWidth = document.documentElement.clientWidth || window.innerWidth
    setHtmlFontSize(newWidth)
  })
  
  // 监听屏幕方向变化（移动端）
  if (window.orientation !== undefined) {
    window.addEventListener('orientationchange', () => {
      // 延迟执行，确保屏幕方向变化完成
      setTimeout(() => {
        const newWidth = document.documentElement.clientWidth || window.innerWidth
        setHtmlFontSize(newWidth)
      }, 100)
    })
  }
}

/**
 * 将px转换为rem
 * @param {number} px - 像素值
 * @returns {string} rem值
 */
function px2rem(px) {
  return (px / BASE_FONT_SIZE) + 'rem'
}

/**
 * 将rem转换为px
 * @param {number} rem - rem值
 * @returns {number} 像素值
 */
function rem2px(rem) {
  return rem * BASE_FONT_SIZE
}

export {
  initRem,
  setHtmlFontSize,
  px2rem,
  rem2px,
  BASE_WIDTH,
  BASE_FONT_SIZE
} 